export const opportunitiesFilterTypes = Object.freeze({
    BOND: 'Bonds',
    SDI: 'SDIs',
    T_BILL: "T-Bills"
});